import React, { useState, useRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import moment from 'moment';

import MonetizationOn from '@material-ui/icons/MonetizationOn';

import List from '~/containers/List';
import Request from '~/providers/Request';
import ModalDelete from '~/components/ModalDelete';
import { showPack, editPack, createPack } from '~/config/routes';
import { AbilityContext } from '~/contexts/Can';

import PackContext from './context';

function PackList() {
  const { t } = useTranslation();
  const [modalInfo, setModalInfo] = useState({ show: false });
  const { delRecord } = useContext(PackContext);
  const ability = useContext(AbilityContext);
  const listEl = useRef(null);

  const trAttr = (attr) => t(`packs.attributes.${attr}`);

  function handleDeletionModal(id, title) {
    setModalInfo({ show: true, id, title });
  }

  async function handleDelete() {
    try {
      await Request.del(`/admin/packs/${modalInfo.id}`);
      delRecord(modalInfo.id);
      listEl.current.onQueryChange();
      toast.success(t('delete-toast-success'));
    } catch (e) {
      toast.error(t('delete-toast-fail'));
    } finally {
      setModalInfo({ show: false });
    }
  }

  const actions = ['search', 'filter'];

  if (ability.can('new', 'Packs')) {
    actions.push('new');
  }
  if (ability.can('edit', 'Packs')) {
    actions.push('edit');
  }
  if (ability.can('delete', 'Packs')) {
    actions.push('del');
  }
  if (ability.can('show', 'Packs')) {
    actions.push('show');
  }

  return (
    <div>
      <List
        deleteAction={handleDeletionModal}
        routeToNew={createPack}
        routeToEdit={editPack}
        routeToShow={showPack}
        listEl={listEl}
        path={'/admin/packs/'}
        actions={actions}
        paperProps={{
          Icon: MonetizationOn,
          iconColor: 'blue',
          title: t('packs.defPlural'),
        }}
        columns={[
          {
            title: trAttr('id'),
            field: 'id',
            type: 'numeric',
            precision: 0,
            includeThousandsSeparator: false,
          },
          { title: trAttr('name'), field: 'name', type: 'string' },
          {
            title: trAttr('created_at'),
            field: 'created_at',
            type: 'datetime',
          },
          {
            title: trAttr('updated_at'),
            field: 'updated_at',
            type: 'datetime',
          },
        ]}
        context={PackContext}
        recordMap={(record) => ({
          ...record,
          created_at: record.created_at
            ? moment(record.created_at).format('DD/MM/YYYY HH:mm')
            : null,
          updated_at: record.updated_at
            ? moment(record.updated_at).format('DD/MM/YYYY HH:mm')
            : null,
        })}
      />

      <ModalDelete
        id={modalInfo.id}
        name={modalInfo.title}
        modal={modalInfo.show}
        deleteAction={handleDelete}
        onClose={() => setModalInfo({ show: false })}
      />
    </div>
  );
}

export default React.memo(PackList);
